import { WebFsError } from '#common/types';
export class InvalidFilespaceStateError extends WebFsError {
}
export class FilespaceVersionError extends WebFsError {
}
export class FileSystemReadOnlyException extends WebFsError {
    constructor(message = 'Filespace is in read-only mode.') {
        super(message);
    }
}
